const Video = {
  init() {
    Video.events();
  },

  events() {
    $(".video__overlay").on("click", (e) => {
      const btn = $(e.currentTarget);

      const parentEl = btn.closest(".video");
      btn.fadeOut(200);
      parentEl.find(".video__video").fadeIn(200);
      parentEl.find("video")[0].load();
      parentEl.find("video")[0].play();
    });
  },
};

export default Video;
